import { ref } from "vue";
export function useCommentable(initialCommentsCount = 0, initialComments = []) {
  const comments = ref(initialComments);
  const commentsCount = ref(initialCommentsCount);
  function handleCreatedComment(comment) {
    comment.comments_count = 0;
    commentsCount.value++;
    comments.value.splice(0, 0, comment);
  }
  function handleUpdatedComment(comment, data) {
    Object.keys(data).forEach((key) => {
      comment[key] = data[key];
    });
  }
  function handleDestroyedComment(comment) {
    comments.value.splice(comments.value.indexOf(comment), 1);
    commentsCount.value--;
  }
  return {
    comments,
    commentsCount,
    handleCreatedComment,
    handleUpdatedComment,
    handleDestroyedComment
  };
}
